import { AffiliationStatus } from "@api/shared-runtime/enums";
import type { RouterOutputs } from "@/trpc";

export type EndedProviderRow =
  RouterOutputs["organizationBusinessUnitAffiliation"]["listEnded"]["rows"][number];

const ROSTER_STATUS_LABELS: Record<AffiliationStatus, string> = {
  [AffiliationStatus.Hired]: "Hired",
  [AffiliationStatus.Candidate]: "Candidate",
};

export function getEndedFromStatusLabel(status: AffiliationStatus): string {
  return ROSTER_STATUS_LABELS[status];
}
